{
    "welcome": "Bienvenue",
    "getStarted": "Commencer"
}
